import { render, staticRenderFns } from "./BlogBox.vue?vue&type=template&id=3cbe294c&"
import script from "./BlogBox.vue?vue&type=script&lang=js&"
export * from "./BlogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports